import type { CoachingGoal } from '@efdigital/ll-addon-data';
import type { CoachingCoacheeCohortGoalsModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/goals';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export type CoachingCoacheeCohortGoalsGoalModel =
  CoachingCoacheeCohortGoalsModel & {
    goal: CoachingGoal | undefined;
  };

export default class CoachingCoacheeCohortGoalsGoalRoute extends Route<CoachingCoacheeCohortGoalsGoalModel> {
  @service declare router: RouterService;

  model(params: { goal_id: string }): CoachingCoacheeCohortGoalsGoalModel {
    const parent = this.modelFor(
      'coaching.coachee.cohort.goals'
    ) as CoachingCoacheeCohortGoalsModel;
    const goal = parent.goals.find(
      (entry) => String(entry.id) === String(params.goal_id)
    );

    if (!goal) {
      void this.router.replaceWith(
        'coaching.coachee.cohort.goals.index',
        parent.program_id,
        parent.cohort_id
      );
    }

    return { ...parent, goal };
  }
}
